import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import logo from "../Assets/jiologo.svg";
import logoEnterprise from "../Assets/jiologoenterprise.svg";

import profile from "../Assets/profile.svg";
import profileBlue from "../Assets/profile-blue.svg";
import profileDD from "../Assets/profile-dd.svg";
import signout from "../Assets/signout.svg";
import settings from "../Assets/settings.svg";
import help from "../Assets/help.svg";
import notification from "../Assets/images/svg/NotificationIcon.svg";
import ConsoleLocalStorage from "../storage/storage";

import "../stylesheets/Navbar.scss";
import { useQueryClient } from "react-query";

const Navbar = (props) => {
  const queryClient = useQueryClient();
  const [showDropDown, setShowDropDown] = React.useState(false);
  const history = useHistory();

  const [org, setOrg] = useState({})
  useEffect(()=>{
    setOrg(ConsoleLocalStorage.getOrganization())
  },[]) 

  const bodyListner = (e) => {
    if (showDropDown) {
      setShowDropDown(false)
    }
  }
  document.addEventListener("click", bodyListner);

  const handleLogout = () => {
    ConsoleLocalStorage.clearStorageExceptFTU();
    queryClient.removeQueries();
    history.push("/");
  };
  const closeDropDown = () => {
    setShowDropDown(false);
  };

  const disableClick = (e) => {
    e.stopPropagation();
    setShowDropDown(true);
  }
  return (
    <nav className="nav" >
      <div className="nav_logo">
        <div
          className={`${props.clickDisabled ? "c-pointer-block" : "c-pointer"} d-flex d-justify-center d-align-center`}
          onClick={() =>
            ConsoleLocalStorage.getOrganization()?.id
              ? history.push("/console")
              : history.push("/")
          }
        >
          <img src={logo} alt="logo" className="nav_logo" />
          <span className="badge theme__font--medium text-dark-jungle-green">BETA</span>
          {org && org.tags && org.tags.toLowerCase()==='enterprise' && <span className="enterprise theme__font--medium text-dark-jungle-green">ENTERPRISE</span>}
        </div>
      </div>

      {props.showSignup ? (
        <Link to="/signup" style={{ textDecoration: "none" }}>
          <span style={{ textDecoration: "none" }} className="signup">
            Sign Up
          </span>
        </Link>
      ) : (
        <ul className="nav_ul">
          <li>
            <img
              src={notification}
              alt="logo"
              className="mr-1 fluid logo text-secondary nav_icon"
            />
          </li>
          <li>
            <div>
              <img
                onClick={(e) => {
                  e.stopPropagation()
                  setShowDropDown(!showDropDown);
                }}
                src={showDropDown ? profileBlue : profile}
                alt="logo"
                className="mr-1 cursor-pointer fluid logo text-secondary nav_icon pointer"
              />
              <ul className={showDropDown ? "dd-menu" : "dd-menu d-none"}>
                <li className = {props.clickDisabled ? "auto-cursor opac-05" : "c-pointer"}
                  onClick={(e) => {
                    if (!props.clickDisabled) {
                      history.push("/console/profile");
                      setShowDropDown(false);
                    }else{
                      disableClick(e)
                    }

                  }}
                >
                  <img src={profileDD} alt="logo" />
                  My Profile
                </li>
                <li className="divider"></li>
                <li className = "auto-cursor opac-05" onClick={disableClick}>
                  <img src={settings} alt="logo" />
                  Settings
                </li>
                <li className = "auto-cursor opac-05" onClick={disableClick}>
                  <img src={help} alt="logo" />
                  Help
                </li>
                <li className="divider"></li>
                <li onClick={handleLogout}>
                  <img src={signout} alt="logo" />
                  Sign Out
                </li>
              </ul>
            </div>

            {/* <IconButton
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
            >
              <img src={profile} alt="logo" className=" user" />
            </IconButton> */}
            {/* <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              className={classes.tooltip}
              open={open}
              onClose={handleClose}
            >
              <MenuItem className={classes.tooltip} onClick={handleClick}>
                Log Out
              </MenuItem>
              {/* <MenuItem onClick={handleClose}>My account</MenuItem> 
            </Menu> */}
          </li>
        </ul>
      )}
    </nav>

  );
};

export default Navbar;
